import EA from '../helpers/init';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, CustomEase);

export default EA.Methods.heroScrollAnim = ($this) => {
    let tl;
    const pinnedElement = $this;
    const deviceWrapper = $this.querySelector('.device-wrapper');
    const scrollableElement = $this.querySelector('.scroll-img');
    const blobsWrapperDesktop = $this.parentNode.querySelector('.blobs-wrapper:not(.mobile)');
    const blobsWrapperMobile = $this.parentNode.querySelector('.blobs-wrapper.mobile');
    const mobileBlobs = blobsWrapperMobile.querySelectorAll('.blob');
    const desktopBlobs = blobsWrapperDesktop.querySelectorAll('.blob');
    const section = $this.closest('section');

    const mm = gsap.matchMedia();

    const minHorizontalOffset = 0;
    const maxHorizontalOffset = 5;

    const blobPositions = [0.09, 0.20, 0.31, 0.42, 0.53, 0.64, 0.75, 0.86, 0.97];
    const blobPositionsMobile = [0, 0.09, 0.20, 0.31, 0.42, 0.53, 0.64, 0.75, 0.86];
    const blobPositionsMobileFade = [0, 0.09, 0.20, 0.31, 0.42, 0.53, 0.64, 0.75, 0.86];

    $this.parentNode.querySelectorAll('.blob').forEach((blob) => {
        blob.style.setProperty('--blob-horizontal-offset', `${minHorizontalOffset + Math.random() * (maxHorizontalOffset - minHorizontalOffset)}%`);
    });

    const HIDE_PX = 32; 
    const SHOW_PX = 32; 

    // Desktop blobs 
    const hiddenDesktopBlobs = new WeakMap();

    function updateDesktopBlobs() {
        if (!desktopBlobs.length) return;

        const deviceBottom = deviceWrapper.getBoundingClientRect().bottom;
        const deviceTop = deviceWrapper.getBoundingClientRect().top;

        desktopBlobs.forEach((blob) => {
            const blobBottom = blob.getBoundingClientRect().bottom;

            const isHidden = hiddenDesktopBlobs.get(blob) === true;

            const shouldHide = isHidden
                ? (blobBottom >  deviceBottom - SHOW_PX || blobBottom < deviceTop + SHOW_PX) 
                : (blobBottom > deviceBottom + HIDE_PX || blobBottom < deviceTop - HIDE_PX);

            if (shouldHide !== isHidden) {
                hiddenDesktopBlobs.set(blob, shouldHide);
                blob.classList.toggle('hide', shouldHide);
            }
        });
    }

    let rafDesktopId = 0;
    function scheduleDesktopBlobsUpdate() {
        cancelAnimationFrame(rafDesktopId);
        rafDesktopId = requestAnimationFrame(updateDesktopBlobs);
    }

    scheduleDesktopBlobsUpdate();

    function positionDesktopBlobs() {
        const imgHeight = scrollableElement.offsetHeight;
        const deviceTop = deviceWrapper.offsetTop;

        desktopBlobs.forEach((blob, i) => {
            const fraction = parseFloat(blob.dataset.scrollPosition) || blobPositions[i] || 0;
            const pxFromTop = deviceTop + (fraction * imgHeight);
            blob.style.top = `${pxFromTop}px`;
        });
    }

    function positionMobileBlobs() {
        const imgHeight = scrollableElement.offsetHeight;

        mobileBlobs.forEach((blob, i) => {
            const fraction = blobPositionsMobile[i] || 0;
            const prevFraction = blobPositionsMobile[i - 1] || 0;
            const prevBlobHeight = i > 0 ? mobileBlobs[i - 1].offsetHeight : 0;

            // console.log(prevBlobHeight);

            if (i === 0) {
                blob.style.marginTop = '0px';
            } else {
                const rawMargin = (fraction - prevFraction) * imgHeight;
                blob.style.marginTop = `${rawMargin - prevBlobHeight}px`;
            }
        });
    }

    mm.add('(min-width: 2561px)', () => {
        const deviceWrapperHeight = deviceWrapper.offsetHeight;
        const scrollableElementHeight = scrollableElement.offsetHeight;

        positionDesktopBlobs();

        tl = gsap.timeline({
            defaults: {
                ease: 'none',
            },
            scrollTrigger: {
                trigger: pinnedElement,
                pin: true,
                start: 'bottom bottom-=50',
                end: `bottom+=${scrollableElementHeight}px top`,
                scrub: 1,
                markers: false,
                invalidateOnRefresh: true,
                toggleClass: {
                    targets: deviceWrapper,
                    className: 'is-pinned',
                },
                onUpdate: () => { scheduleDesktopBlobsUpdate(); },
                onScrubComplete: () => { scheduleDesktopBlobsUpdate(); }
            },
            duration: 1,
        });

        tl.fromTo(scrollableElement, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);

        tl.fromTo(blobsWrapperDesktop, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);
    });

    mm.add('(min-width: 1001px) and (max-width: 2560px)', () => {
        const deviceWrapperHeight = deviceWrapper.offsetHeight;
        const scrollableElementHeight = scrollableElement.offsetHeight;

        positionDesktopBlobs();

        tl = gsap.timeline({
            defaults: {
                ease: 'none',
            },
            scrollTrigger: {
                trigger: pinnedElement,
                pin: true,
                start: 'bottom bottom-=50',
                end: `bottom+=${scrollableElementHeight}px top`,
                scrub: 1,
                markers: false,
                invalidateOnRefresh: true,
                toggleClass: {
                    targets: deviceWrapper,
                    className: 'is-pinned',
                },
                onUpdate: () => { scheduleDesktopBlobsUpdate(); },
                onScrubComplete: () => { scheduleDesktopBlobsUpdate(); }
            },
            duration: 1,
        });

        tl.fromTo(scrollableElement, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);

        tl.fromTo(blobsWrapperDesktop, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);
    });

    mm.add('(max-width: 1000px)', () => {
        positionMobileBlobs();

        const deviceWrapperHeight = deviceWrapper.offsetHeight;
        const scrollableElementHeight = scrollableElement.offsetHeight;
        
        tl = gsap.timeline({
            defaults: {
                ease: 'none',
            },
            scrollTrigger: {
                trigger: section,
                pin: true,
                start: 'top-=44 top',
                end: `bottom+=${scrollableElementHeight}px top`,
                scrub: 1,
                markers: false,
                invalidateOnRefresh: true,
                toggleClass: {
                    targets: deviceWrapper,
                    className: 'is-pinned',
                },
                onUpdate: (self) => { 
                    mobileBlobs.forEach((blob, i) => {
                        const fraction = blobPositionsMobileFade[i] || 0;
                        const nextFraction = blobPositionsMobileFade[i + 1] || 1;

                        const isActive = self.progress >= fraction && self.progress <= nextFraction;

                        if(i === 1) {
                            // console.log(self.progress, fraction, nextFraction);
                        }
                        
                        gsap.to(blob, {
                            opacity: isActive ? 1 : 0,
                            duration: 0.3,
                            overwrite: true,
                        });
                    });
                },
            },
            duration: 1,
        });

        tl.fromTo(scrollableElement, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);

        tl.fromTo(blobsWrapperMobile, {
            y: 0,
        }, {
            y: `-${scrollableElementHeight - deviceWrapperHeight}px`,
            duration: 1
        }, 0);
    });
};